module.exports = __webpack_public_path__ + "static/media/Portrait-10189.73643447.jpg";